import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../../Header/PageHeader";
import CustomFolderList from "../../Components/CustomFolderList";
import GridView from "../../Components/GridView";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../../Network/apiCallGateway";
import { DataContext } from "../../context/DataContext";
import SharedPassword from "./SharedPasswords";
import SharedEnvs from "./SharedEnvs";
import SharedFolders from "./SharedFolders";
function Shared() {
  const history = useHistory();
  const { setBrudCrumb } = useContext(DataContext);

  const [tab, setTab] = useState("fol");
  const [viewType, setViewType] = useState("list");
  const [shareFolderPage, setShareFolderPage] = useState(1);
  const [shareEnvPage, setshareEnvPage] = useState(1);
  const [folderId, setFolderId] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);

  const confirmtoggle = () => setConfirmModal(!confirmModal);

  return (
    <div>
      <PageHeader
        title={"Shared"}
        importCSV={false}
        shared={true}
        tab={tab}
        leftHeader={false}
        setTab={(e) => setTab(e)}
        viewType={viewType}
        setViewType={(e) => setViewType(e)}
        splitIcon={tab === "pass" ? true : false}
      />
      {tab === "fol" ? <SharedFolders viewType={viewType} /> : null}

      {tab === "env" ? <SharedEnvs viewType={viewType} /> : null}

      {tab === "pass" ? <SharedPassword viewType={viewType} /> : null}
    </div>
  );
}

export default Shared;
